var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SafeVerifyModal',{attrs:{"smstype":5},on:{"on-ok":_vm.confirmHandle},model:{value:(_vm.modalVis.fundPassVerify),callback:function ($$v) {_vm.$set(_vm.modalVis, "fundPassVerify", $$v)},expression:"modalVis.fundPassVerify"}})
}
var staticRenderFns = []

export { render, staticRenderFns }